import StepsApi from '@/api/Steps/api'
import {get} from 'lodash'

export default {
  methods: {
    async getLastStep (projectId) {
      try {
        const resp = await StepsApi.getSteps({page: 1, limit: 1, projectId})
        return get(resp.data, ['steps', 0], {})
      } catch (e) {
        console.error(e)
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getLastStep.js